import React from 'react';

export const StatCard = ({ title, value, sub, color, icon }) => (
    <div className="bg-white p-6 rounded-[32px] shadow-sm border border-slate-100 flex flex-col justify-between hover:shadow-xl hover:shadow-slate-200/50 transition-all cursor-default">
        <div className="flex justify-between items-start">
            <div className={`p-3 rounded-2xl ${color} bg-opacity-10 text-${color.split('-')[1]}-600`}>{icon}</div>
            <span className="text-[10px] font-bold text-slate-400 uppercase tracking-wider">{sub}</span>
        </div>
        <div className="mt-4">
            <p className="text-slate-500 text-sm font-medium">{title}</p>
            <h3 className="text-2xl font-bold text-slate-900 mt-1">{value}</h3>
        </div>
    </div>
);